import { axios, getConfigs, IRequestConfig, MedicalOrder } from './api'
import { DmpSubmission } from './dmpSubmissionService'

export interface BackgroundTask {
  uid: string
  status: string
  taskName: string
  siteId: number
  entityId: number
  entityName: string
  medicalOrderId: number
  reportId: number
  medicalOrder: MedicalOrder
  patientId: number
  holdReason?: string
  error?: string
  createdAt: Date
  updatedAt: Date
  completedAt: Date
  site?: { label: string }
  dmpSubmission?: DmpSubmission | null
}

export interface PaginatedTasksResponse {
  items: BackgroundTask[]
  page: number
  pageSize: number
  totalCount: number
  totalPages: number
}
export interface FindTasksParams {
  taskName?: TaskNameEnum
  medicalOrderId?: number
  reportId?: number
  siteId?: number
  status?: TaskStatus
  page?: number
  pageSize?: number
  dmpStatus?: string
  patientName?: string
  search?: string
  dateFrom?: string
  dateTo?: string
}

export interface BaseTaskPayload {
  error?: string
  scheduledAt?: string
  delayInMs?: number
  holdReason?: string
}
export enum TaskStatus {
  Pending = 'Pending',
  InProgress = 'InProgress',
  Completed = 'Completed',
  Failed = 'Failed',
  Scheduled = 'Scheduled',
  Cancelled = 'Cancelled',
  Hold = 'Hold',
}
export enum DmpEnum {
  APPROVED = 'APPROVED',
  DEPRECATED = 'DEPRECATED',
  SUBMITTED = 'SUBMITTED',
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
  FAILED = 'FAILED',
}
export enum TaskNameEnum {
  DmpPublishTask = 'DmpPublishTask',
}

export interface ReleaseBackgroundTaskBody {
  recipientPhone: string
  recipientEmail: string
}

export class BackgroundTasksService {
  static getBackgroundTasks(
    params: FindTasksParams,
  ): Promise<PaginatedTasksResponse> {
    return new Promise((resolve, reject) => {
      const url = 'background-tasks'

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        {
          params: {
            status: params.status?.toLowerCase(),
            ...params,
          },
        },
      )

      axios(configs, resolve, reject)
        .then((res) => {
          resolve(res.data as PaginatedTasksResponse)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static releaseBackgroundTask(
    uid: string,
    updatedPayload?: Partial<BaseTaskPayload>,
  ): Promise<BackgroundTask> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        `background-tasks/${uid}/release`,
        {},
      )
      configs.data = updatedPayload ?? {}
      axios(configs, resolve, reject)
    })
  }

  static cancelTask(uid: string): Promise<BackgroundTask> {
    return new Promise((resolve, reject) => {
      const url = `background-tasks/${uid}/cancel`

      const configs: IRequestConfig = getConfigs(
        'patch',
        'application/json',
        url,
        {},
      )

      axios(configs, resolve, reject)
        .then((res) => {
          resolve(res.data as BackgroundTask)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
